import { render, staticRenderFns } from "./FooterMap.vue?vue&type=template&id=20eb5f36&scoped=true"
import script from "./FooterMap.vue?vue&type=script&lang=js"
export * from "./FooterMap.vue?vue&type=script&lang=js"
import style0 from "./FooterMap.vue?vue&type=style&index=0&id=20eb5f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb5f36",
  null
  
)

export default component.exports